import { render, staticRenderFns } from "./HomeApp.vue?vue&type=template&id=f8fb86f0&"
import script from "./HomeApp.vue?vue&type=script&lang=js&"
export * from "./HomeApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports